var map = {
	"./add-sector.svg": "ac7e",
	"./box.svg": "4185",
	"./card.svg": "927d",
	"./catalog.svg": "4869",
	"./chart.svg": "a41b",
	"./delete.svg": "0f72",
	"./edit.svg": "e565",
	"./filter-2.svg": "c14f",
	"./filter.svg": "3dd4",
	"./folder-add.svg": "d2b7",
	"./grid-2.svg": "6e63",
	"./grid.svg": "8e4d",
	"./layer-2.svg": "e7e0",
	"./layer.svg": "69f8",
	"./link.svg": "9023",
	"./offer.png": "7cf6",
	"./options.svg": "bb5e",
	"./pin.svg": "0925",
	"./plus-2.svg": "5610",
	"./plus.svg": "9730",
	"./product.svg": "c385",
	"./save.svg": "c7f9",
	"./settings-price.svg": "24a6",
	"./swap.svg": "35cf",
	"./view.svg": "91f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d8e";